import { render, staticRenderFns } from "./SplitsFilter.vue?vue&type=template&id=5b9b8a4d&scoped=true&"
import script from "./SplitsFilter.vue?vue&type=script&lang=js&"
export * from "./SplitsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b8a4d",
  null
  
)

export default component.exports